import { Icon, IconButton, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import styles from './document-instructions.module.scss';
import { displayToast } from '@sanlam-glacier/app-common/modules/toasts';
import { DocumentInstructionsProps } from 'modules/case-tracking/types/documents-required/documents-required.types';

const DocumentInstructions = ({ clientName, instructionId }: DocumentInstructionsProps) => {
  const email = 'GlacierPartners.AlexForbes@glacier.co.za';
  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    displayToast({
      toastId: 'intermediaryEmailCopied',
      title: 'Copy successful',
      message: `Email address copied successfully.`,
      status: 'success'
    });
  };

  return (
    <div className={styles.container}>
      <Icon className={styles.lightBulbIcon} icon={ICONS_ENUM.ACTION_LIGHTBULB_OUTLINE} />
      <div className={styles.content}>
        <Typography
          className={styles.heading}
          variant={Typography.VARIANT.B3}
          weight={Typography.WEIGHT.MEDIUM}
        >
          Document submission instructions
        </Typography>

        <div className={styles.contentItem}>
          <span className={styles.bullet}>•</span>

          <div className={styles.emailContainer}>
            <Typography className={styles.text} variant={Typography.VARIANT.B3}>
              Email all required documents to:&nbsp;
            </Typography>

            <span className={styles.emailContent}>
              <Typography className={styles.email} variant={Typography.VARIANT.B3}>
                {email}
              </Typography>
              <IconButton
                className={styles.copyButton}
                variant={IconButton.VARIANT.TERTIARY}
                onClick={handleCopy}
              >
                <Icon className={styles.copyIcon} icon={ICONS_ENUM.CONTENT_COPY} />
              </IconButton>
            </span>
          </div>
        </div>
        <div className={styles.contentItem}>
          <span className={styles.bullet}>•</span>
          <div className={styles.referenceContainer}>
            <div className={styles.contentItem}>
              <Typography className={styles.text} variant={Typography.VARIANT.B3}>
                Reference number:&nbsp;
              </Typography>
              <span>
                <Typography
                  className={styles.text}
                  variant={Typography.VARIANT.B3}
                  weight={Typography.WEIGHT.MEDIUM}
                >
                  {clientName} {instructionId}
                </Typography>
              </span>
            </div>
            <Typography className={styles.subtext} variant={Typography.VARIANT.B4}>
              Please include your reference number in the subject line of your email.
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentInstructions;
